module.exports = __webpack_public_path__ + "static/box6-ff588dfd994bcb18b43965040a060710.webp";